import { render, staticRenderFns } from "./special-lib.vue?vue&type=template&id=660ebda6&scoped=true&"
import script from "./special-lib.vue?vue&type=script&lang=ts&"
export * from "./special-lib.vue?vue&type=script&lang=ts&"
import style0 from "./special-lib.vue?vue&type=style&index=0&id=660ebda6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660ebda6",
  null
  
)

export default component.exports